module.exports = __webpack_public_path__ + "img/5.3aa507f.png";